// import axios from "axios";

// const axiosInstance = axios.create()
// axiosInstance.defaults.baseURL = `${process.env.REACT_APP_API_URL}/api/v1/${organization.id}`;
// axiosInstance.defaults.withCredentials = true;
// axiosInstance.defaults.credentials = 'include';
// export default axiosInstance;

import axios from "axios";

const AUTH_ERROR_CODES = ['TOKEN_INVALID', 'AUTH_HEADER_MISSING', 'AUTH_HEADER_INVALID_FORMAT'];

const handleAuthError = (error) => {
    const status = error.response?.status;
    const errorCode = error.response?.data?.error?.code;
    const requestUrl = error.config?.url || '';

    // Skip auth redirect for Kratos endpoints
    const isKratosRequest = requestUrl.includes('/auth/') || requestUrl.includes('/self-service/') || requestUrl.includes('/sessions/whoami');

    // Check for auth errors:
    // - HTTP 401 Unauthorized (from our API only, not Kratos)
    // - Known auth error codes from API
    if (!isKratosRequest && (status === 401 || (errorCode && AUTH_ERROR_CODES.includes(errorCode)))) {
        localStorage.clear();
        window.location.href = '/login?session_expired=true';
        return Promise.reject(error);
    }

    return Promise.reject(error);
};

const addMethodGetAllPages = (axiosInstance) => {
    axiosInstance.get_all_pages = async (endpoint, page_size = 1000, page_key = 'page') => {
        let allItems = [];
        let currentPage = '';
        let hasNext = true;

        while (hasNext) {
            const response = await axiosInstance.get(endpoint, {
                params: {
                    [page_key]: currentPage,
                    page_size: page_size
                }
            });

            // Add items from current page to the result
            allItems = [...allItems, ...response.page];

            // Update pagination state
            hasNext = response.paging.has_next;
            currentPage = response.paging.next;
        }

        return allItems;
    };
};

export const createAxiosInstanceWithOrgId = (organizationId) => {
    console.log(`creating axios org instance for ${organizationId}`);
    const orgIdInstance = axios.create( {
        baseURL: `${process.env.REACT_APP_API_URL}/api/v1/${organizationId}`,
        withCredentials: true
    });
    orgIdInstance.interceptors.response.use(
        response => {
            // Any status code within the range of 2xx causes this function to trigger
            // Do something with response data
            return response.data;
        },
        error => {
            // Handle authentication errors
            return handleAuthError(error);
        }
    );

    // Add custom method for paginated requests
    addMethodGetAllPages(orgIdInstance);

    console.log('created orgIdInstance', orgIdInstance);
    return orgIdInstance;
};

export const createAxiosInstanceNoOrg = () => {
    console.log(`creating axios org instance no org`);
    const noOrgInstance = axios.create( {
        baseURL: `${process.env.REACT_APP_API_URL}/api/v1`,
        // baseURL: "http://my.com/",
        withCredentials: true
    });
    noOrgInstance.interceptors.response.use(
        response => {
            // Any status code within the range of 2xx causes this function to trigger
            // Do something with response data
            return response.data;
        },
        error => {
            // Handle authentication errors
            return handleAuthError(error);
        }
    );

    // Add the same pagination method to the no-org instance
    addMethodGetAllPages(noOrgInstance);

    console.log('created noOrgInstance', noOrgInstance);
    return noOrgInstance;
};

export const createAxiosInstanceAllOrgs = () => {
    console.log(`creating axios all orgs instance`);
    const allOrgsInstance = axios.create( {
        baseURL: `${process.env.REACT_APP_API_URL}/api/v1/all`,
        withCredentials: true
    });
    allOrgsInstance.interceptors.response.use(
        response => {
            // Any status code within the range of 2xx causes this function to trigger
            // Do something with response data
            return response.data;
        },
        error => {
            // Handle authentication errors
            return handleAuthError(error);
        }
    );

    // Add the same pagination method to the all-orgs instance
    addMethodGetAllPages(allOrgsInstance);

    console.log('created allOrgsInstance', allOrgsInstance);
    return allOrgsInstance;
};

export const createAxiosInstanceInternal = () => {
    console.log(`creating axios internal instance`);
    const internalInstance = axios.create( {
        baseURL: `${process.env.REACT_APP_API_URL}/internal/v1`,
        withCredentials: true
    });
    internalInstance.interceptors.response.use(
        response => {
            // Any status code within the range of 2xx causes this function to trigger
            // Do something with response data
            return response.data;
        },
        error => {
            // Handle authentication errors
            return handleAuthError(error);
        }
    );

    // Add the same pagination method to the internal instance
    addMethodGetAllPages(internalInstance);

    console.log('created internalInstance', internalInstance);
    return internalInstance;
};